module.exports = __webpack_public_path__ + "static/media/provision5.93e1ffec.png";